function stopRKey(evt) {
	evt = (evt) ? evt : ((event) ? event : null);
	var node = (evt.target) ? evt.target : ((evt.srcElement) ? evt.srcElement : null);
	if ((evt.keyCode == 13) && (node.type=="text"))  {return false;}
}

document.onkeypress = stopRKey;

$("#newacct-phone").mask("(999) 999-9999");

jQuery(document).ready(function ($) {

	var x;
	var keytimer;
	var urlParams = new URLSearchParams(window.location.search);

	if (urlParams.has('return_url')) {
		$('.login').attr('href','/login.html?return_url=' + urlParams.get('return_url'));
	}

	$.when( loginCheck ).then(function() {
		if (userLoggedIn) {
			window.location.replace('/index.html');
		}
	});



	window.addEventListener('load', function() {
		var form = document.getElementById('register_form');
		form.addEventListener('submit', function(event) {
		  event.preventDefault();
		  event.stopPropagation();

		  if (form.checkValidity() === false) {

			// Form is not valid so show errors
			var wall = $("#errors").show();

			// Remove old error messages
			wall.find("p").remove();

			// add new ones
			$.each($('div.invalid-feedback'), function(index, error) {
			  wall.append("<p class='customErrors customBtnErr'>" + $(error).text() + "</p>");
			});

		  } else {
			// Form is valid so hide errors and submit
			$('#errors,#register-submit-div').hide();
			$('#register-wait').show();

			$.ajax({
			   type: "POST",
			   url: form.action,
			   data: $(form).serialize(), // serializes the form's elements.
			   dataType  : 'json',
			   encode  : true,
			   success: function(data) {
				  $('#register-wait').hide();
				  if (! data.success) {
					$('#errors,#register-submit-div').show();
					var wall = $("#errors");
					wall.find("p").remove();
					wall.append("<p><strong> Error submitting form: " + data.error + "</strong></p>");
					grecaptcha.reset();
				  } else {
					$('#register_form').hide();
					$('#register-thanks').show();
				  }
			   }
			 });
		  }

		  form.classList.add('was-validated');

		}, false);
	}, false);



	$(document).on('input propertychange', '#email_input' , function(){
		if (x) { x.abort(); }
		clearTimeout(keytimer);
		keytimer = setTimeout( function() {
			x = $.getJSON( "/utils/email_check.php" , {email: $('#email_input').val()}, function (data) {
				console.log(data);
				if (data===1) {
					$('#recoveryLink').attr('href', '/lost-password.html?email=' + $('#email_input').val());
					$('#dupe_name').show();
					$('#dupe_name_block').val('');
				} else {
					$('#dupe_name').hide();
					$('#dupe_name_block').val('1');
				}
			});
		}, 500);
	});


	$(document).on('keyup', '#pwd_input', function (){
		var score = passwordStrength($(this).val());
		$("#passwordDescription").html(score['desc']);
		$("#passwordStrength").attr('class',"strength" + score['val']);
		$("#user_pass_strength").val(score['val']);
	});

	$(document).on('keyup', '.pwd', function (){
		if ($("#pwd_conf").val()===$('#pwd_input').val()) {
			$('#pwd_matches').val('1');
			$('#pwd_blank').hide();
			$('#pwd_nomatch').hide();
			$('#pwd_match').show();
		}
		else {
			$('#pwd_matches').val('');
			$('#pwd_blank').hide();
			$('#pwd_nomatch').show();
			$('#pwd_match').hide();
		}
		if ($('#pwd_input').val()==='') {
			$('#pwd_blank').show();
			$('#pwd_nomatch').hide();
			$('#pwd_match').hide();
		}	else {
			$('#pwdstr').attr('required','required');
			$('#pwd_matches').attr('required','required');
		}

	});

});